import React from 'react';
import { PropTypes } from 'prop-types';
import Dialog from '../../components/modal/Dialog';
import { Button } from '@unite-us/ui';
export function ChooseOneServiceTypeModal(_ref) {
  var programs = _ref.programs,
    modalRef = _ref.modalRef,
    servicesState = _ref.servicesState,
    findServiceName = _ref.findServiceName,
    onServiceSelectionChange = _ref.onServiceSelectionChange,
    onConfirm = _ref.onConfirm,
    closeDialog = _ref.closeDialog;
  var renderServiceCheckbox = function renderServiceCheckbox(program, serviceToFind) {
    var _servicesState$find;
    var serviceName = findServiceName({
      serviceToFind: serviceToFind
    });
    var isSelected = ((_servicesState$find = servicesState.find(function (service) {
      return (service === null || service === void 0 ? void 0 : service.programId) === program.id && (service === null || service === void 0 ? void 0 : service.serviceId) === serviceToFind;
    })) === null || _servicesState$find === void 0 ? void 0 : _servicesState$find.selected) || false;
    return /*#__PURE__*/React.createElement("div", {
      key: "".concat(program.id, "-").concat(serviceToFind),
      className: "ui-checkbox-field pt-4"
    }, /*#__PURE__*/React.createElement("input", {
      id: "service-".concat(program.id, "-").concat(serviceToFind),
      type: "checkbox",
      checked: isSelected,
      onChange: function onChange() {
        return onServiceSelectionChange(program.id, serviceToFind);
      }
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: "service-".concat(program.id, "-").concat(serviceToFind),
      className: "ui-form-field__label"
    }, serviceName));
  };
  var renderProgram = function renderProgram(program) {
    if (program.services.length > 1) {
      return /*#__PURE__*/React.createElement("div", {
        key: program.id,
        className: "bg-white border border-solid border-blue-border rounded mt-6 p-4 w-full h-full box-border"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "text-base mb-1 text-text-blue font-proxima font-bold"
      }, "Program: ".concat(program.name)), /*#__PURE__*/React.createElement("p", null, "Select one service type that meets the client's needs."), program.services.map(function (serviceToFind) {
        return renderServiceCheckbox(program, serviceToFind);
      }));
    }
  };
  var getDialogMessage = function getDialogMessage() {
    return "Sending multiple referrals to the same program increases the likelihood of rejection.";
  };
  return /*#__PURE__*/React.createElement(Dialog, {
    ref: modalRef,
    title: "Simplify your referrals",
    close: closeDialog,
    dataTestId: "auth-requests-details-dialog",
    titleClass: "text-2xl font-semibold font-black",
    dialogContentStyles: {
      background: '#FAFBFC',
      paddingBottom: '110px'
    },
    customSize: {
      width: '650px'
    },
    actions: /*#__PURE__*/React.createElement("div", {
      className: "confirmation-dialog__actions"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "confirmation-dialog__actions--skip mr-6",
      label: "Skip, send multiple referrals",
      onClick: closeDialog
    }), /*#__PURE__*/React.createElement(Button, {
      className: "confirmation-dialog__actions--apply",
      onClick: onConfirm,
      label: "Apply selections",
      primary: true
    }))
  }, /*#__PURE__*/React.createElement("p", null, getDialogMessage()), programs.map(renderProgram));
}
ChooseOneServiceTypeModal.propTypes = {
  programs: PropTypes.array.isRequired,
  referrals: PropTypes.array.isRequired,
  modalRef: PropTypes.object.isRequired,
  servicesState: PropTypes.array.isRequired,
  findServiceName: PropTypes.func.isRequired,
  onServiceSelectionChange: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired
};
export default ChooseOneServiceTypeModal;
//# sourceMappingURL=ChooseOneServiceTypeModal.js.map